<template>
	<div class="tc-chart-row"
		v-statemachine= "sm_row">
		<div v-if="isDisplayBar">
			<TCGhostSchedule
				v-bind:ghost_schedule="ghost_schedule"
				v-bind:item="item" />
			<div v-for="schedule in schedules"
				v-bind:key="schedule.code">
				<div v-if="!isAllDay(schedule) || isBarEditting(schedule)">
					<TCBar
						v-bind:item="schedule"
						v-bind:schedules="schedules"
						v-bind:name="item.name"
						v-bind:isEditable="isEditable"
						v-bind:isExpanded="isExpanded"
						v-bind:bar_editing="bar_editing"
						v-on:bar-move-start="barMoveStart"
						v-on:request-ghost-schedule="onRequestGhostSchedule"
						v-on:bar-stretch-start="barStretchStart"
						v-on:update_schedule_info="updateScheduleInfo"
						ref="bar" />
				</div>
				<div v-else>
					<TCAllDay 
						v-bind:item="schedule"
						v-bind:schedules="schedules"
						v-bind:name="item.name"
						v-bind:count="countAllday"
						v-bind:isEditable="isEditable"
						v-bind:isExpanded="isExpanded"
						v-on:update_schedule_info="updateScheduleInfo"/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import TCBar from './TCBar';
import TCAllDay from './TCAllDay';
import TCGhostSchedule from './TCGhostSchedule';
import EventTarget from '../../classes/EventTarget';
import BarEventTarget from '../../classes/BarEventTarget';
import MouseState from '../../classes/MouseState';
import MouseStateMachine from '../../classes/MouseStateMachine';
import ScheduleListRow from '../../classes/ScheduleListRow';
import Schedule from '../../classes/Schedule';
import ScheduleTick from '../../classes/ScheduleTick';
import clonedeep from 'lodash/cloneDeep';

const findChartRow = (elem) => {
	let found = null;

	if (elem.classList.contains('tc-chart-row')) {
		found = elem;
	} else {
		found = elem.closest('.tc-chart-row');
	}

	return found;
}

export default {
	name: 'TCChartRow',
	components: {
		TCBar,
		TCAllDay,
		TCGhostSchedule,
	},
	props: [
		"item",
		"isParent",
		"isExpanded",
		"isEditable",
		"ghost_schedule",
		"bar_editing",
	],
	data: function() {
		const state_nop = new MouseState({});
		
		return {
			state_nop: state_nop,
			sm_row: new MouseStateMachine(state_nop),
			mouse_position: {
				layer: {
					x: 0,
				},
				page: {
					x: 0,
				},
			},
		};
	},
	mounted: function() {
		this.sm_row.next(this.defaultStateRow());
	},
	methods: {
		barMoveStart: function(e) {
			this.$emit('bar-move-start', e);
		},
		barStretchStart: function(e) {
			this.$emit('bar-stretch-start', e);
		},
		updateScheduleInfo: function(e) {
			this.$emit('update_schedule_info', e);
		},
		onRequestGhostSchedule: function(e) {
			this.$emit("request-ghost-schedule", e);
		},
		isAllDay: function(schedule) {
			if (schedule.all_day)
				return true;
			
			let day = this.$store.getters['chart/current_day_as_date'];
			
			if (schedule.isAllDay(day)) {
				return true;
			}
			
			return false;
		},
		isBarEditting: function(schedule) {
			if(!this.bar_editing)
				return false;
			
			return this.bar_editing.is_editing && this.bar_editing.before_schedule.code === schedule.code;
		},
		createNewSchedule: function() {
			let tick = this.$store.getters['chart/chartTick'];
			let source_begin = this.$store.getters.createDateCurrentBeginningDay;
			let begin = ScheduleTick.createTickFromDate(source_begin);
			let ticks = Math.floor(this.mouse_position.layer.x / tick.size );
			
			begin.addMinutes(ticks * tick.minutes);
			let project_code = '';
			let member_code = '';
			let task_code = '';
			if(this.item.item_type === ScheduleListRow.ITEM_TYPE.PROJECT) {
				project_code = this.item.code;
			} else if (this.item.item_type === ScheduleListRow.ITEM_TYPE.TASK) {
				project_code = this.item.project_code;
				member_code = this.item.member_code;
				task_code = this.item.code;
			}
			return new Schedule({
				project_code: project_code,
				member_code: member_code,
				task_code: task_code,
				begin: begin,
				end: begin.clone().addMinutes(tick.minutes),
			});
		},
		defaultStateRow: function() {
			if (!this.isEditable)
				return this.state_nop;

			const state_default = new MouseState({
				down: (e) => {
					if(this.item.item_type === ScheduleListRow.ITEM_TYPE.MEMBER) {
						this.sm_row.next(state_member_parent);
					} else {
						let obj = e.targetTouches ? e.targetTouches[0] : e;
						let touchX = obj.pageX;
						let row = findChartRow(obj.target);
						if (row === null)
							return;
						let clientRect = row.getBoundingClientRect();
						let positionX = clientRect.left + window.pageXOffset;
						let x = touchX - positionX;
					
						this.mouse_position.layer.x = x;
						this.mouse_position.page.x = touchX;
					}
				},
				longpress: (e) => {
					e.stopPropagation();
					let s = this.createNewSchedule();
					
					this.$store.dispatch('addSchedule', {
						schedule: s,
					});
					this.$nextTick(() => {
						let bar = this.$refs.bar;
						let vc = bar[bar.length - 1];
						this.$emit('hscroll-stop', e);
						this.$emit('bar-stretch-start', new BarEventTarget({
							target: vc,
							target_type: EventTarget.TARGET_TYPE.SCHEDULE_STRECH_END,
							x: this.mouse_position.page.x,
						}));
					});
				},
			});
			const state_member_parent = new MouseState({
				up: () => {
					this.sm_row.next(state_default);
				},
			});
				
			return state_default;
		},
	},
	computed: {
		isDisplayBar: function() {
			if(this.$store.getters['chart/isDisplayMemberList'])
				return (!this.isParent) || (this.isParent && !this.isExpanded);

			return true;
		},
		schedules: function() {
			let all_day = null;
			let list = [];
			let schedules = [];
			let day = clonedeep(this.$store.getters['chart/current_day_as_date']);
			schedules = this.item.schedules.filter( s => s.isOverlapOneDay(day));
			schedules.forEach(s => {
				if (!this.isBarEditting(s) && this.isAllDay(s)) {
					if (all_day === null)
						all_day = s;
				} else {
					list.push(s);
				}
			});
			if(all_day != null)
				list.unshift(all_day);
			return list;
		},
		hscroll: function() {
			return this.$store.getters['chart/hscroll'];
		},
		countAllday: function() {
			let count = 0;
			this.item.schedules.forEach(s => {
				if (!this.isBarEditting(s) && this.isAllDay(s))
					count += 1;
			});
			return count - 1;
		},
	},
	watch: {
		isEditable: function() {
			this.sm_row.next(this.defaultStateRow());
		},
	},
}
</script>
<style>
	.tc-chart-row {
		position: relative;
		width: 100%;
		color: white;
		height: 49px;
		padding: 0;
	}
</style>
